__turbopack_context__.v({
  "childRow": "FolderRow-module__L9fHXq__childRow",
});
